import React from 'react';
import type { NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';
import AddRepositoryModalApp from '../../../../add-repository-modal/view/index.tsx';

type Props = {
	baseUrl: string;
	projectKey: string;
	onAddItemCompleted: (arg1: { item: NavigationItem | undefined }) => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<AddRepositoryModalApp
		baseUrl={props.baseUrl}
		projectId={props.projectKey}
		onCompleted={props.onAddItemCompleted}
	/>
);
